import script from "./RadialMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RadialMenu.vue?vue&type=script&setup=true&lang=js"

import "./RadialMenu.vue?vue&type=style&index=0&id=21d9a040&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d9a040"]])

export default __exports__